import { Link } from "@remix-run/react";
import { Home } from "lucide-react";
import { Button } from "./button";

interface ErrorPageProps {
  title?: string;
  message?: string;
  statusCode?: number;
  showHomeButton?: boolean;
}

export function ErrorPage({
  title = "Something went wrong",
  message = "An unexpected error occurred. Please try again later.",
  statusCode,
  showHomeButton = true,
}: ErrorPageProps) {
  return (
    <div className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background px-4">
      {/* Blurred background status code */}
      {statusCode && (
        <div className="pointer-events-none absolute inset-0 flex items-center justify-center">
          <span className="select-none text-[20rem] font-black leading-none text-muted-foreground/10  sm:text-[25rem] md:text-[30rem]">
            {statusCode}
          </span>
        </div>
      )}

      {/* Content */}
      <div className="relative z-10 w-full max-w-md text-center">
        <h1 className="mb-4 text-3xl font-bold tracking-tight">{title}</h1>

        <p className="mb-8 text-lg text-muted-foreground">{message}</p>

        {/* ⛔ "Head back" went to "/", which sends a super-admin to the admin
            panel, not back to the page they were on. Try this page again first. */}
        {showHomeButton && (
          <Button
            className="mb-3 gap-2"
            onClick={() => window.location.reload()}
          >
            Try this page again
          </Button>
        )}
        {showHomeButton && (
          <Link to="/">
            <Button className="gap-2 border border-[rgba(129,156,106,0.18)] bg-[var(--yield-mint)] text-[var(--info-700)] hover:bg-[var(--yield-celery-light)] hover:text-[var(--info-700)]">
              <Home className="h-4 w-4" />
              Head back
            </Button>
          </Link>
        )}
      </div>
    </div>
  );
}
